import React from 'react';

const MCATUpsellContent: React.FC = (props) => {
  return (
    <ul className="u-padding-L-m">
      <li>Comprehensive MCAT prep</li>
      <li>380+ content review records</li>
      <li>700+ practice questions</li>
      <li>Full-length practice tests</li>
      <li>Customizable study schedules</li>
      <li>Score improvement guaranteed</li>
    </ul>
  );
};

export default MCATUpsellContent;
